import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';


function NotFound() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (countdown === 0) {
      navigate('/');
      return;
    }

    setAnimate(true);
    const timer = setTimeout(() => {
      setCountdown(countdown - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [countdown, navigate]);

  useEffect(() => {
    if (animate) {
      const timeout = setTimeout(() => setAnimate(false), 200);
      return () => clearTimeout(timeout);
    }
  }, [animate]);

  const countdownStyle = {
    fontWeight: 'bold',
    display: 'inline-block',
    minWidth: '1.5em', // enough for two digits
    textAlign: 'center',
    fontFamily: 'monospace', // consistent digit width
    transition: 'transform 0.2s cubic-bezier(0.4, 2, 0.6, 1)',
    transform: animate ? 'scale(1.4)' : 'scale(1)',
    color: '#2e7d32',
  };

  return (
    <div className="container py-4">
      <h1 className="display-4 mb-4 text-center">Hmm, this page hasn't evolved yet. 🧬</h1>
      <p>
        No worries! We'll redirect you to our main page in{' '}
        <span style={countdownStyle}>{countdown}</span> seconds. Or click <a href="/">here</a>.
      </p>
      <p>Code: 404 - Not Found</p>
    </div>
  );
}

export default NotFound;
